(function () {
  const TEXT    = '© Alexy Berthelot';
  const OPACITY = 0.13;

  // 1. Cache le bouton loupe
  var s = document.createElement('style');
  s.textContent = '.product__media-zoom-lightbox { display:none!important; }';
  document.head.appendChild(s);

  // 2. Bloque le clic sur modal-opener (empêche zoom)
  document.addEventListener('click', function (e) {
    if (e.target.closest('modal-opener')) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // 3. Bloque le clic droit sur les images
  document.addEventListener('contextmenu', function (e) {
    if (e.target.tagName === 'IMG') e.preventDefault();
  }, true);

  // 4. Filigrane sur l'image principale uniquement (premier .product__media)
  function addWatermark(img) {
    if (img.dataset.wm) return;
    img.dataset.wm = '1';

    var parent = img.parentElement;
    if (parent && parent.tagName === 'PICTURE') parent = parent.parentElement;
    if (!parent) return;

    if (window.getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }

    var canvas = document.createElement('canvas');
    canvas.style.cssText =
      'position:absolute;top:0;left:0;width:100%;height:100%;' +
      'pointer-events:none;z-index:9999;background:transparent;display:block;';
    parent.appendChild(canvas);

    function draw() {
      var w = parent.offsetWidth;
      var h = parent.offsetHeight;
      if (!w || !h) { setTimeout(draw, 300); return; }

      canvas.width  = w * 2;
      canvas.height = h * 2;

      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.scale(2, 2);

      var fs = Math.max(w, h) * 0.030;
      ctx.font         = 'bold ' + fs + 'px Arial,sans-serif';
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';

      ctx.save();
      ctx.translate(w / 2, h / 2);
      ctx.rotate(-Math.PI / 7);

      var sx = fs * 9, sy = fs * 5;
      for (var x = -w; x < w; x += sx) {
        for (var y = -h; y < h; y += sy) {
          // Blanc uniquement
          ctx.fillStyle = 'rgba(255,255,255,' + OPACITY + ')';
          ctx.fillText(TEXT, x, y);
        }
      }
      ctx.restore();
    }

    if (img.complete && img.naturalWidth) {
      setTimeout(draw, 200);
    } else {
      img.addEventListener('load', function () { setTimeout(draw, 200); }, { once: true });
    }

    new ResizeObserver(draw).observe(parent);
  }

  function run() {
    // Image principale uniquement = premier .product__media img
    var firstMedia = document.querySelector('.product__media img, .product-media-container img');
    if (firstMedia) addWatermark(firstMedia);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', run)
    : run();

  setTimeout(run, 500);
  setTimeout(run, 1500);
  setTimeout(run, 3000);

})();